export default "__VITE_ASSET__7e38a4dd__"